// Quantity buttons for Cart items in Cart page
$(document).on("click", ".cart__product-qty-button", function (e) {
  const qty_input = $(this).siblings(".cart__product-qty");
  let value = parseInt(qty_input.val());

  if ($(this).hasClass("minus-button")) {
    value--;
  } else if ($(this).hasClass("plus-button")) {
    value++;
  }

  if (value === 0) {
    $(".minus-button").attr("disabled", true);
  } else {
    $(".minus-button").attr("disabled", false);
  }

  qty_input.val(value);
});

// Collection/Search Filters

const sortEnum = {
  manual: "Recommended",
  "created-descending": "New In",
  "best-selling": "Best Sellers",
  "price-ascending": "Price Low to High",
  "price-descending": "Price High to Low",
  default: "Sort By",
};

$(document).ready((e) => {
  document.getElementsByTagName("html")[0].style.visibility = "visible";

  var status = window.localStorage.getItem("details-filter");
  if (status == "open") {
    $("#filter").attr("open", true);
    if (screen.width <= 768) {
      document.querySelector("body").classList.toggle("no-scroll");
    }
  } else {
    //$("#filter").attr('open', false)
  }

  let urlParams = new URLSearchParams(window.location.search);
  function hasFilterParams(params) {
    for (let param of params.keys()) {
      if (param.startsWith("filter.")) {
        return true;
      }
    }
    return false;
  }
  if (hasFilterParams(urlParams)) {
    if (screen.width > 768) {
      $("#filter").attr('open', true);
    }
  }

  $("details").on("toggle", function (event) {
    var id = $(this).attr("id");
    var isOpen = $(this).attr("open");
    if (id == "filter" && screen.width <= 768) {
      window.localStorage.setItem("details-" + id, isOpen);
    }
  });

  const desktopFilterForm = document.getElementById("FilterForm");
  const checkBoxSwitch = desktopFilterForm.querySelectorAll('[id^="Filter-"]');

  const params = new URLSearchParams(window.location.search);
  let sortParam;
  let searchParam;

  if (params.has("sort_by")) {
    sortParam = params.get("sort_by");
  }

  if (params.has("q")) {
    searchParam = params.get("q");
  }

  // Attach an event handler to the checkox
  checkBoxSwitch.forEach((s) =>
    s.addEventListener("change", function (e) {
      $("#FilterForm").delay(200).submit();
    })
  );

  var selectElement = document.getElementById("SortBy");
  var dropdownMenu = document.getElementById("sortDropdownMenu");

  dropdownMenu.innerHTML = "";

  var buttonElement = document.createElement("button");

  if (screen.width <= 768) {
    buttonElement.textContent = "Sort By";
    buttonElement.className = "collection-search_filter-close-button";
    buttonElement.setAttribute("id", "sortToggle");
    dropdownMenu.appendChild(buttonElement);
  }

  for (var i = 0; i < selectElement.options.length; i++) {
    var option = selectElement.options[i];
    var optionElement = document.createElement("div");
    optionElement.textContent = option.textContent;

    optionElement.className = "sort-dropdown-menu-option";
    optionElement.setAttribute("data-value", option.value);

    if (sortParam == option.value) {
      optionElement.classList.add("bold");
    } else {
      optionElement.classList.remove("bold");
      if (option.value == "manual" && !sortParam) {
        optionElement.classList.add("bold");
      }
    }
    optionElement.addEventListener("click", function () {
      selectElement.value = this.getAttribute("data-value");
      params.set("sort_by", this.getAttribute("data-value"));
      location.href = "?" + params.toString();
    });
    dropdownMenu.appendChild(optionElement);
  }

  document.querySelectorAll("#sortToggle").forEach((s) => {
    if (sortParam) {
      s.innerText = sortEnum[sortParam];
    } else {
      s.innerText = sortEnum["default"];
    }

    s.addEventListener("click", function (e) {
      e.preventDefault;
      var dropdownMenu = document.getElementById("sortDropdownMenu");
      dropdownMenu.classList.toggle("hidden");
      if (screen.width <= 768) {
        document.querySelector("body").classList.toggle("no-scroll");
      }
    });
  });

  document.querySelectorAll(".collection-search_filter-apply").forEach((s) => {
    s.addEventListener("click", function (e) {
      e.preventDefault;

      document
        .querySelectorAll(".collection-search_filter-filter-facet")
        .forEach((s) => {
          window.localStorage.setItem("details-filter", false);
        });
    });
  });

  document
    .querySelectorAll(".collection-search_filter-close-button")
    .forEach((s) => {
      s.addEventListener("click", function (e) {
        e.preventDefault;

        document
          .querySelectorAll(".collection-search_filter-filter-facet")
          .forEach((s) => {
            window.localStorage.setItem("details-filter", false);
          });
      });
    });

  document
    .querySelector(".collection-search_filter-facet")
    .addEventListener("click", function () {
      if (screen.width <= 768) {
        document.querySelector("body").classList.toggle("no-scroll");
      }
    });

  document
    .querySelectorAll(".collection-search_filter-accordion-button")
    .forEach((s) =>
      s.addEventListener("click", function (e) {
        e.preventDefault;
        const sId = s.getAttribute("id");
        document.querySelector("#accordion-" + sId).classList.toggle("hidden");
        s.classList.toggle("minus");
        s.classList.toggle("plus");
      })
    );

  window.addEventListener("scroll", (event) => {
    let scroll = this.scrollY;
    if (window.matchMedia("screen and (max-width: 768px)").matches) {
      if (scroll > 128) {
        document
          .querySelector(".collection-search_filter-facets")
          .classList.add("sticky-mobile");
      } else {
        document
          .querySelector(".collection-search_filter-facets")
          .classList.remove("sticky-mobile");
      }
    }
  });

  applyProductGridChanges();
  document.querySelectorAll(".collection-search_filter-reset").forEach((s) =>
    s.addEventListener("click", function () {
      if (searchParam) {
        location.href = "search?q=" + searchParam;
      } else {
        location.href = location.pathname;
      }
    })
  );

  if (searchParam) {
    var inputElement = document.createElement("input");

    inputElement.setAttribute("type", "hidden");
    inputElement.setAttribute("name", "q");
    inputElement.setAttribute("value", searchParam);

    var filter = document.getElementById("FilterForm");

    filter.appendChild(inputElement);

    var mobileInputElement = document.createElement("input");

    mobileInputElement.setAttribute("type", "hidden");
    mobileInputElement.setAttribute("name", "q");
    mobileInputElement.setAttribute("value", searchParam);

    var mobileFilter = document.getElementById("FilterFormMobile");

    mobileFilter.appendChild(mobileInputElement);
  }
});
